/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import _get from 'lodash/get';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from 'digit-playback-app/src/data/configure-store';
import App from 'digit-playback-app/src/app';
import rootSaga from 'digit-playback-app/src/data/root-saga';
import trackAsync from '../utils/tracking';

let render = ReactDOM.hydrate;
let initialData = window.INIT_DATA;
window.trackAsync = trackAsync;
// Hacky detection to determine if application is running as standalone webpack-dev-server
// webpack-dev-server template does not set the global variable window.INIT_DATA
// TODO: Work with MWPA to get web-scripts to pass down environment variables
if (!initialData) {
    render = ReactDOM.render;
    initialData = '{}';
}

const urlParams = new URLSearchParams(window.location.search);
const topicIdParam = urlParams.get('t');
const pathArray = window.location.pathname.split('/topic/');
const topicIdValue = pathArray[1];
let pageId = window.pageMeta.club || 'milb';
if (topicIdParam) {
    pageId = `topic_video_${topicIdParam}`;
} else if (topicIdValue) {
    pageId = `topic_video_${topicIdValue}`;
}

window.milbDoubleclick.siteCoreConfig({
    adUnitHierarchy1: window.pageMeta.adUnitHierarchy1,
    adUnitHierarchy2: window.pageMeta.adUnitHierarchy2,
    thresholdsMap: ['xs', 's', 'm', 'l', 'xl'],
    thresholds: [0, 568, 768, 1024, 1304],
    appView: window.pageMeta.appView,
    skinElement: 'main',
    responsive: true,
    targeting: {
        locale: window.pageMeta.locale,
        devicetype: window.deviceBootstrap().formFactor || 'desktop',
        env: window.pageMeta.env,
        pathname: window.location.pathname.split('/').splice(1),
        pageid: pageId
    }
});

initialData = JSON.parse(initialData);
const store = configureStore(initialData);
store.runSaga(rootSaga);

const basePath = _get(initialData, 'appRuntimeConfig.basePath');

render(
    <Provider store={store}>
        <BrowserRouter basename={basePath}>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
